import {
  LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE,
  LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST,
  LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS,
  UPDATE_MESSAGE_STATUS_API_CALL,
} from '../actions/actionTypes';

const initialState = {
  isFetchingChat: false,
  checkEmptyRequest: null,
  loadChatError: null,
  chat: [],
  messageUpdate: false,
};

const loadChat = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST:
        return {
          ...state,
          isFetchingChat: false,
          checkEmptyRequest: null,
        };
      case LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS:
        return {
          ...state,
          isFetchingChat: true,
          chat: action.payload,
          loadChatError: null,
        };
      case LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE:
        return {
          ...state,
          isFetchingChat: false,
          chat: [],
          loadChatError: 'Unable to load previous chat',
        };
      case UPDATE_MESSAGE_STATUS_API_CALL:
        return {
          ...state,
          messageUpdate: true,
        };
      default:
        return state;
    }
  }
};

export default loadChat;
